// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Dmjmx","content":"styles_content__a8GIa","fadeIn":"styles_fadeIn__xpb4e"};